<template>
  <div class="options">
    <div class="options__weight">
      <div
        v-for="(list, idx) in weightList"
        class="option__weight--item"
        :class="{
          option__active:
            list.value === -1
              ? overWeight
              : list.value === getDeliveryOptions.weight,
          wide: idx === 0 || idx === 3,
        }"
        @click="changeWeight(list.value)"
      >
        <div>{{ list.title }}</div>
      </div>
    </div>
    <input
      v-if="overWeight"
      class="options__input"
      :class="{
        'options__input--error': !weightValidation,
      }"
      placeholder="(필수) 물품의 총 예상 무게를 입력해 주세요"
      type="text"
      v-onlyNumber
      v-focus
      :value="weightOverKg"
      @input="updateOverKg($event.target.value)"
      maxlength="4"
      :disabled="loadingStatus"
    />
    <div class="error-msg" v-if="!weightValidation && overWeight">
      20kg이 초과된 물품이 아닙니다.
    </div>
  </div>
</template>

<script>
import mixinOrder from "@/mixins/mixinOrder";
import _ from "lodash";

export default {
  props: ["loadingStatus"],
  mixins: [mixinOrder],
  data() {
    return {
      weightList: [
        { title: "3kg 이하", value: 3 },
        { title: "5kg 이하", value: 5 },
        { title: "10kg 이하", value: 10 },
        { title: "20kg 이하", value: 20 },
        { title: "20kg 초과", value: -1 },
      ],
      overWeight: false,
      weightOverKg: null,
      weightValidation: true,
    };
  },
  computed: {
    computedOverKg: {
      get() {
        return this.weightOverKg;
      },
      set(value) {
        if (value === -1) {
          this.changeWeight(-1);
        }
        if (value === "" || value < 21) {
          this.changeWeight(-1);
          this.weightValidation = false;
        }
        this.weightOverKg = value;
        if (this.weightOverKg > 20) {
          this.changeWeight(value);
          this.weightValidation = true;
        }
      },
    },
  },
  methods: {
    updateOverKg: _.debounce(function (value) {
      this.computedOverKg = value.replace(/[^0-9]/g, "");
    }, 800),
    changeWeight(value) {
      if (value == -1) {
        this.overWeight = true;
        this.updateWeight(0);
      } else if (value > 20) {
        this.updateWeight(value);
        this.$emit("calculator");
        this.overWeight = true;
      } else {
        this.updateWeight(value);
        this.$emit("calculator");
        this.overWeight = false;
        this.weightOverKg = "";
      }
    },
  },
};
</script>

<style src="@/assets/css/newGlobal.css" scoped></style>
<style scoped>
.options {
  display: flex;
  flex-direction: column;
}
.options__weight {
  display: grid;
  gap: 8px;
}
.option__weight--item {
  box-sizing: border-box;
  background-color: var(--gray-100);
  border: 1.5px solid transparent;
  display: flex;
  justify-content: center;
  padding: 12px;
  color: var(--gray-700);
  font-weight: 500;
  line-height: 24px;
  font-size: 16px;
  border-radius: 16px;
  cursor: pointer;
  height: 48px;
}

.option__weight--item:hover {
  background-color: var(--gray-200);
  border-color: var(--gray-200);
  transition-duration: 0.3s;
}
.option__active {
  transition-duration: 0.3s;
  box-sizing: border-box;
  border: 1.5px solid rgba(46, 163, 255, 0.6) !important;
  box-shadow: 0px 8px 16px -4px rgba(63, 83, 107, 0.08);
  background-color: var(--primary-100) !important;
  color: var(--primary-400) !important;
}
.options__input {
  margin-top: 20px;
  width: 100%;
  transition-duration: 0.3s;
  border: 1px solid var(--primary-200);
  background-color: var(--primary-100);
}
.options__input:focus {
  transition-duration: 0.3s;
  border: 1px solid var(--primary-200) !important;
}

.options__input--error {
  transition-duration: 0.1s;
  border: 1px solid var(--red-200) !important;
  background-color: var(--red-100) !important;
}

.options__input--error:focus {
  border: 1px solid var(--red-200) !important;
}

.error-msg {
  margin-top: 4px;
  color: var(--red-400);
  line-height: 22px;
  font-size: 14px;
}
@media all and (min-width: 1024px) {
  .options__weight {
    grid-template-rows: 1fr;
    grid-template-columns: repeat(5, 1fr);
  }
}
@media all and (max-width: 1023px) {
  .options__weight {
    display: grid;
    grid-template-columns: repeat((6, 1fr));
    grid-template-rows: 1fr 1fr;
    gap: 8px;
  }

  .option__weight--item:nth-child(1),
  .option__weight--item:nth-child(2) {
    grid-row: 1 / span 1;
    grid-column: span 3;
  }

  .option__weight--item:nth-child(3),
  .option__weight--item:nth-child(4),
  .option__weight--item:nth-child(5) {
    grid-row: 2 / span 1;
    grid-column: span 2;
  }
}
</style>
